import React, { FC } from "react";
import {
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps,
} from "@mui/material";

const FormControlLabel: FC<FormControlLabelProps> = (props) => (
  <MuiFormControlLabel {...props} />
);

export default FormControlLabel;
